module.exports = __webpack_public_path__ + "img/695-f9f8e9.png";